import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Components/TestReview.css";
import useBlockBackNavigation from "../src/hooks/useBlockBackNavigation.js";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

const TestReview = () => {

  const navigate = useNavigate();
  const { attemptId } = useParams();

  const [studentInfo, setStudentInfo] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [studentAnswers, setStudentAnswers] = useState({});
  const [score, setScore] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  window.history.pushState(null, "", window.location.href);

  const handlePopState = () => {
  alert("You cannot go back after submitting the test. Redirecting to login.");
  navigate("/login", { replace: true });
  };
  window.addEventListener("popstate", handlePopState);

  return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);
  useEffect(() => {
    const fetchReviewData = async () => {
      try {
        // 1️⃣ Fetch attempt details (get student + paper ID)
        const attemptRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Students/attempt-details-by-id/${attemptId}`);
        const { studentId, studentName, paperId } = attemptRes.data;
        setStudentInfo({ studentId, studentName, paperId });

        // 2️⃣ Fetch student profile (get standard)
        const profileRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Students/profile?studentId=${studentId}`);
        setStudentInfo(prev => ({ ...prev, standard: profileRes.data.standard }));

        // 3️⃣ Fetch all questions in this paper
        const questionRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Students/questions-by-paper/${paperId}`);
        const fetchedQuestions = questionRes.data;

        // 4️⃣ Fetch student's selected answers from backend
        const answerRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Students/answers-by-attempt/${attemptId}`);
        const answerData = answerRes.data; // [{questionId, selectedAnswer}, ...]

        const answerMap = {};
        answerData.forEach(a => {
          answerMap[a.questionId] = a.selectedAnswer;
        });
        setStudentAnswers(answerMap);

        // 5️⃣ Calculate score
        let calculatedScore = 0;
        fetchedQuestions.forEach(q => {
          if (answerMap[q.id]?.trim() === q.correctAnswer?.trim()) {
            calculatedScore += 2; // 2 marks per question
          }
        });

        setScore(calculatedScore);
        setQuestions(fetchedQuestions);
      } catch (err) {
        console.error("Failed to fetch review data:", err);
        alert("Failed to load review data.");
      } finally {
        setLoading(false);
      }
    };

    fetchReviewData();
  }, [attemptId]);

  const handleBack = () => navigate("/");

  if (loading) return <div className="loading-container">Loading review...</div>;

  const totalQuestions = questions.length;
  const totalMarks = totalQuestions * 2;
  const passMarks = totalMarks / 2;
  const optionLabels = ["A", "B", "C", "D"];

  return (
    <div className="review-container">
      <div className="testing">
        <h3 className="review-title">Test Review</h3>
        <button className="pass-btn" onClick={handleBack}>Back</button>
      </div>
      {/* Student Info */}
      <div className="student-details">
        <p><strong>Name :</strong> {studentInfo?.studentName}</p>
        <p><strong>Std :</strong> {studentInfo?.standard || "N/A"}</p>
        {/* <p><strong>Paper ID :</strong> {studentInfo?.paperId}</p> */}
        {/* <p><strong>Attempt ID :</strong> {attemptId}</p> */}
        <p><strong>Total Marks :</strong> {score}/{totalMarks}</p>
        {/* <button className="pass-btn" onClick={handleBack}>Back</button> */}
      </div>

      {/* Score Summary */}
      <div className="score-cards">
        <div className="score-cardd">
          <div className="circle blue">{totalQuestions}</div>
          <div className="label">Total Questions</div>
        </div>
        <div className="score-card">
          <div className="circle green">{score / 2}</div>
          <div className="label">Correct Answers</div>
        </div>
      </div>

      {/* Questions Review */}
      <div className="question-Testbox">
        <p className="test-h4">Review : Answers and Explanation For This Test</p>

        {questions.map((q, idx) => {
          const selected = studentAnswers[q.id];
          const isAnswered = selected && selected.trim() !== "";
          const isCorrect = selected?.trim() === q.correctAnswer?.trim();

          // Determine question status
          let statusText = !isAnswered
            ? "⟳ Skipped"
            : isCorrect
              ? "✓ Correct"
              : "❌ Wrong";

          return (
            <div key={q.id} className="question-review-item">
              <p>
                <strong>{idx + 1}. {q.questionText}</strong>{" "}
                <span style={{ float: "right" }}>{statusText}</span>
              </p>

              {q.questionImageUrl && (
                <div className="review-question-image">
                  <img src={q.questionImageUrl} alt="Question" style={{ maxWidth: "400px", maxHeight: "400px" }} />
                </div>
              )}

              {["A", "B", "C", "D"].map((label) => {
                const option = q[`option${label}`];
                const optionImage = q[`option${label}ImageUrl`];
                if (!option) return null;

                // Mark options based on selection and correctness
                let mark = "";
                if (!isAnswered && label === q.correctAnswer) mark = "✅"; // Skipped: show correct
                if (isAnswered) {
                  if (label === selected && isCorrect) mark = "✅";  // Correct selection
                  else if (label === selected && !isCorrect) mark = "❌"; // Wrong selection
                  else if (label === q.correctAnswer && !isCorrect) mark = "✅"; // Show correct if wrong
                }

                return (
                  // <p key={label}>
                  //   {label}) {option} {mark}
                  // </p>

                  <div key={label} className="review-option">
                    <p>{label}) {option} {mark}</p>
                    {optionImage && (
                      <img
                        src={optionImage}
                        alt={`Option ${label}`}
                        style={{ maxWidth: "200px", maxHeight: "200px" }}
                      />
                    )}
                  </div>
                );
              })}

              <p>
                <strong>Correct Answer:</strong> {q.correctAnswer}) {q[`option${q.correctAnswer}`]}
              </p>
            </div>
          );
        })}

      </div>
    </div>
  );
};

export default TestReview;

